import store from '@store'
import config from '@utils/Config.js'
import toast from '@utils/toast'
import { FORBIDDEN_CODE } from '../../constants/responseCode'

var unauthorized = ['/user/login']
let user = store.getters['getUser']
let token = store.getters['getToken']

function setVariables () {
    user = store.getters['getUser']
    token = store.getters['getToken']
}

function configureBody(url, body) {

    // If its form data don't stringify it
    if(body instanceof FormData) {
        // console.log(token)
        // console.log(user)

        body.append('API_KEY', store.getters.keys.api_key)
        body.append('code', token.token)
        body.append('user', user.user)
        return body

    } else {
        // If the route doesn't require api and user don't add them
        if(unauthorized.includes(url)){
            return JSON.stringify(body)
        } else {
            body.API_KEY = store.getters.keys.api_key
            body.code = body.code || token?.token
            body.user = body.user || user?.user
            return JSON.stringify(body)
        }
    }
}

export default async function request (url, method, body={}) {
  setVariables()
  if (url === '/get/schema'){
    body.API_KEY = store.getters.keys.api_key
    body = JSON.stringify(body)
  } else {
    console.log('other request')
    body = configureBody(url, body)
  }
  url = config.address + url

  return await fetch(url, {method, body})
    .then(async response => {
      const text = await response.text()
      try {
        return text ? JSON.parse(text) : { code: response.status, result: response.ok ? 'success' : 'failure' }
      } catch (parseError) {
        if (!response.ok) {
          return {
            code: response.status,
            result: 'failure',
            message: `Server returned HTTP ${response.status}: ${response.statusText || 'Internal Server Error'}`
          }
        }
        return {
          code: -1,
          result: 'failure',
          message: 'Invalid response from server'
        }
      }
    })
    .catch(err => {
      if (err && err.status === FORBIDDEN_CODE) {
        toast.errorMessage('Unable to connect to API.')
      }

      throw err
    })
}
